<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
  <div class="col-md-12 mx-auto">
    <h3>Lista de bonos</h3>
  </div>
  <hr />
  <div class="row align-items-center mb-3">
    <div class="col-md-6">
      <div class="input-group">
        <input
          type="text"
          id="table-complete-search"
          name="searchText"
          class="form-control"
          placeholder="Buscar bono"
          [(ngModel)]="filterText"
          (keyup)="filterRecords()"
        />

        <select
          class="form-select ms-1"
          name="currentOfficeId"
          [(ngModel)]="currentOfficeId"
          id="currentOfficeId"
          (change)="setCurrentOffice($event)"
          *ngIf="rolekey == 'admin'"
        >
          <option value="0" selected="selected">Selecciona sucursal</option>
          <option
            *ngFor="let office of offices"
            value="{{ office.id }}"
            selected="{ office.id == roleofficeid ? 'selected' : '' }"
          >
            {{ office.name }}
          </option>
        </select>

        <button
          class="btn btn-outline-danger ms-1"
          type="button"
          (click)="clearSearch()"
        >
          Limpiar busqueda
        </button>

        <button
          class="btn btn-outline-primary ms-1"
          type="button"
          (click)="reloadInfo()"
          placement="top"
          ngbTooltip="Refrescar informacion"
        >
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>
    </div>
    <div class="col-md-6">
      <div class="d-grip gap-1 d-md-flex justify-content-md-end">
        <a [routerLink]="['/bonus/create']" class="btn btn-outline-success">
          <i class="bi bi-plus-circle"></i>
          Crear bono
        </a>
      </div>
    </div>
  </div>
  <hr />

  <form>
    <ngb-alert
      #selfClosingAlert
      type="{{ typeAlert }}"
      *ngIf="generalMessage != '' && (flagDeleted || flagActive)"
    >
      {{ generalMessage }}
    </ngb-alert>

    <table class="table table-striped">
      <thead>
        <tr>
          <th class="col">ID</th>
          <th class="col">Nombre del bono</th>
          <th class="col">Cantidad minima</th>
          <th class="col">Porcentaje</th>
          <th class="col">Rol</th>
          <th class="col">Tipo de bono</th>
          <th class="col">Sucursal</th>
          <th class="col">Activo?</th>
          <th class="col">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let bonus of filterBonus
              | paginate : { itemsPerPage: 15, currentPage: page }
          "
        >
          <td scope="row">
            {{ bonus.id }}
          </td>
          <td>
            {{ bonus.title }}
          </td>
          <td>
            {{ bonus.amount | currency }}
          </td>
          <td>{{ bonus.percentage }} %</td>
          <td>{{ bonus.role.name }} ({{ bonus.role.key | uppercase }})</td>
          <td>{{ bonus.typeName }}</td>
          <td>{{ bonus.office.name }}</td>
          <td>{{ bonus.active }}</td>
          <td>
            <div class="d-flex d-flex-row">
              <div>
                <a
                  (click)="openActiveInactiveModal(bonus.id, bonus.active_flag)"
                  placement="top"
                  ngbTooltip="Habilitar / Deshabilitar"
                  role="button"
                  class="btn btn-primary"
                >
                  <i class="bi bi-eye-fill" *ngIf="bonus.active == 'Si'"></i>
                  <i
                    class="bi bi-eye-slash-fill"
                    *ngIf="bonus.active != 'Si'"
                  ></i>
                </a>
              </div>
              <div class="ms-2">
                <a
                  [routerLink]="['/bonus/edit', bonus.id]"
                  placement="top"
                  ngbTooltip="Editar"
                  role="button"
                  class="btn btn-primary"
                >
                  <i class="bi bi-pencil-square"></i>
                </a>
              </div>
              <div class="ms-2">
                <a
                  (click)="openDeleteModal(bonus.id, bonus.title)"
                  placement="top"
                  ngbTooltip="Eliminar"
                  role="button"
                  class="btn btn-primary"
                >
                  <i class="bi bi-trash-fill"></i>
                </a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </form>
</div>

<ng-template #modalBonus let-close="close">
  <div class="modal-header">
    <h4 class="modal-title">Eliminar Bono</h4>
    <button class="close ms-auto modal-close-btn" type="button" (click)="close()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
  <div class="modal-body">
    <p>Desea eliminar el bono "{{ bonusNameDeleted }}"</p>
    <div class="row">
      <div class="d-grip gap-2 d-md-flex justify-content-md-end">
        <button
          type="button"
          (click)="deleteBonus(idDeleted)"
          class="btn btn-outline-success"
        >
          Confirmar
        </button>
        <button class="btn btn-outline-danger" type="button" (click)="close()">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #activeBonus let-close="close">
  <div class="modal-header">
    <h4 class="modal-title" *ngIf="!statusActive">Activar Bono</h4>
    <h4 class="modal-title" *ngIf="statusActive">Desactivar Bono</h4>
    <button class="close ms-auto modal-close-btn" type="button" (click)="close()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
  <div class="modal-body">
    <p *ngIf="!statusActive">Desea activar el bono?</p>
    <p *ngIf="statusActive">Desea desactivar el bono?</p>
    <div class="row">
      <div class="d-grip gap-2 d-md-flex justify-content-md-end">
        <button
          type="button"
          (click)="activeInactiveBonus(idActive, statusActive)"
          class="btn btn-outline-success"
        >
          Confirmar
        </button>
        <button class="btn btn-outline-danger" type="button" (click)="close()">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</ng-template>
